module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 12-e712af6d8a88a7c14655e1aa6efa59a5.jpg";